import React, { useState } from "react";
import "../Home.css";
import {  toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

const DonationForm = () => {
  const { token } = useAuth();
  const [formData, setFormData] = useState({
    fullName: "",
    mobile: "",
    age: "",
    gender: "",
    bloodGroup: "",
    type: "",
    address: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      toast.error("You must be logged in to submit the form.");
      setTimeout(() => navigate("/login"), 1500); // 👈 redirect after toast
      return;
    }

    try {
      const BASE_URL = process.env.REACT_APP_API_URL;

      const response = await fetch(`${BASE_URL}/api/donations`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("Form submitted successfully!");
        setFormData({
          fullName: "",
          mobile: "",
          age: "",
          gender: "",
          bloodGroup: "",
          type: "",
          address: "",
        });
      } else {
        toast.error(data.error || "Something went wrong.");
      }
    } catch (error) {
      // console.error("Submission failed:", error);
      toast.error("Failed to submit form.");
    }
  };

  return (
    <section className="donation-form-section" id="registerus-form">
      <h2>Register as Donor or Receiver</h2>
      <form className="donation-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <input
            type="text"
            name="fullName"
            placeholder="Full Name"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="mobile"
            placeholder="Mobile Number"
            value={formData.mobile}
            onChange={handleChange}
            required
            pattern="[0-9]{10}"
          />
        </div>

        <div className="form-row">
          <input
            type="number"
            name="age"
            placeholder="Age"
            value={formData.age}
            onChange={handleChange}
            required
          />
          <select
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            required
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div className="form-row">
          <select
            name="bloodGroup"
            value={formData.bloodGroup}
            onChange={handleChange}
            required
          >
            <option value="">Select Blood Group</option>
            <option value="A+">A+</option>
            <option value="A-">A-</option>
            <option value="B+">B+</option>
            <option value="B-">B-</option>
            <option value="AB+">AB+</option>
            <option value="AB-">AB-</option>
            <option value="O+">O+</option>
            <option value="O-">O-</option>
          </select>

          <div className="radio-group">
            <label>
              <input
                type="radio"
                name="type"
                value="Donor"
                checked={formData.type === "Donor"}
                onChange={handleChange}
                required
              />
              Donor
            </label>
            <label>
              <input
                type="radio"
                name="type"
                value="Receiver"
                checked={formData.type === "Receiver"}
                onChange={handleChange}
                required
              />
              Receiver
            </label>
          </div>
        </div>

        <textarea
          name="address"
          placeholder="Enter Full Address/City/State"
          rows="4"
          value={formData.address}
          onChange={handleChange}
          required
        ></textarea>

        <button type="submit" className="submit-btn">
          Submit
        </button>
      </form>
    </section>
  );
};

export default DonationForm;
